<template>
    <div class="h-full flex flex-col bg-white p-4">
        <h1 class="text-lg font-semibold mb-4">Lista de usuários por permissão</h1>
        <el-row class="flex justify-between">
            <el-col span="24" class="flex">
                <el-col span="12" class="flex">
                    <el-select
                        v-model="selectedRole"
                        clearable
                        filterable
                        class="select__department py-2"
                        placeholder="Selecione a permissão"
                        size="large"
                    >
                        <el-option
                        v-for="item in permissions"
                        :key="item.id + '_' + item.name"
                        :label="String(item.readable_name)"
                        :value="item.name"
                        />
                    </el-select>
                </el-col>
                <el-col span="16" class="flex">
                    <el-input
                        v-model="filterArgs"
                        :disabled="!!!permissionSelected"
                        class="input__size m-2"
                        placeholder="Filtrar por nome/unidade"
                    >
                        <template #append>
                        <i class="ri-search-line"></i>
                        </template>
                    </el-input>
                </el-col>
            </el-col>
            <el-col v-if="listUsers.length" span="8" class="flex items-center">
                <div
                >{{ `Quantidade de usuários: ${listUsers.length}` }}</div>
            </el-col>
        </el-row>
        <ul v-if="!loading" :class="`h-full ${!listUsers.length ? 'flex items-center' : ''} border border-gray-300 rounded-md p-4`">
            <li v-if="updateFilterUsers.length" v-for="user in updateFilterUsers" :key="user.id" @click="() => selectedUser(user)" class="flex items-center gap-4 border-b border-gray-300 p-2 cursor-pointer hover:bg-gray-50 hover:text-blue-600" :class="user.unit === 'USUARIO DESATIVADO' ? 'bg-red-400' : ''">
                <p class="font-semibold">{{ user?.name }}</p>
                <p>{{ user?.unit }}</p>
            </li>
            <li v-else-if="listUsers.length" v-for="user in listUsers" :key="user.id+'_'+user.name" @click="() => selectedUser(user)" class="flex items-center gap-4 border-b border-gray-300 p-2 cursor-pointer hover:bg-gray-50 hover:text-blue-600" :class="user.unit === 'USUARIO DESATIVADO' ? 'bg-red-400' : ''">
                <p class="font-semibold">{{ user?.name }}</p>
                <p>{{ user?.unit }}</p>
            </li>
            <li v-else-if="!listUsers.length && permissionSelected">
                <p class="text-red-500">Não existem usuários com essa permissão.</p>
            </li>
        </ul>
        <ul v-else>
            <li v-if="!permissionSelected" class="h-full flex items-center text-gray-500">
                <img src="../../assets/permission-icon-9.jpg" />
                <h3 class="text-xl text-blue-600 font-medium mt-2">Selecione uma permissão para mostrar os usuários relacionados.</h3>
            </li>
            <li v-else class="flex justify-center items-center h-full">
                <el-col :span="24" class="flex flex-col items-start">
                    <SkeletonTable :total="10" />
                </el-col>
            </li>
        </ul>
        <Modal 
            :visible="isOpenModal"
            @close="isOpenModal = false"
        >
            <template v-slot:header>
                <div>
                    <h3 class="font-semibold text-gray-500">{{ userSelected }}</h3>
                </div>
            </template>
            <el-col :span="24">
                <el-row>
                    <el-tag
                        v-if="!isUnitDCC"
                        class="w-full mb-5 flex items-center justify-center"
                        type="danger"
                        size="large"
                        effect="dark"
                    >
                        <span class="p-2 text-base">Usuário lotado em unidade distinta do DCC</span>
                    </el-tag>
                    <h2 class="w-full font-medium text-base text-white bg-green-500 px-2 py-1 mb-2">Permissões Ativas:</h2>
                    <ul>
                        <li class="mb-2" v-for="group in formatUserLdapPermission" :key="group">
                            <el-tag v-if="group" size="large" type="success">
                            <span class="text-base">
                                {{ group.readable_name }}
                            </span>
                            </el-tag>
                        </li>
                    </ul>
                </el-row>
                <el-row>
                    <h2 class="w-full font-medium text-base text-white bg-blue-500 px-2 py-1 mb-2">Alterar Permissões:</h2>
                    <div class="w-full flex flex-col items-center">
                    <PermissionsList
                        @savePermissions="savePermissionUser"
                        @close="isOpenModal = false"
                        :userDB="{id: userLdapSelected.id}"
                        :userLdap="userLdapSelected"
                        :infoUser="{ 'unidade_id': formattedUnitUserLdap }"
                        :accessUser="{accessLevel, roles: perfilUser}"
                        :menuPermission="true"
                        :accessPermissionInAd="true"
                    />
                    </div>
                </el-row>
            </el-col>
        </Modal>
    </div>
</template>

<script>
import UserService from "@/services/user.service"
import PermissionService from "@/services/permission.service"
import { permissionLdap } from '@/services/ldap/permission.ldap.service'
import { userLdap } from '@/services/ldap/user.ldap.service'
import { permissionAccess } from '@/utils/geral'
import Modal from '@/components/Modal.vue'
import SkeletonTable from '@/components/intranet/SkeletonTable.vue'
import PermissionsList from "@/components/permission/PermissionsList.vue"
import { notificationSuccess } from '@/utils/notification'
import { Keys, GROUP_DCC } from '@/const'
export default {
    name: "Permission",
    components: {
        Modal,
        PermissionsList,
        SkeletonTable
    },
    props: ['perfilUser'],
    data() {
        return {
            loading: true,
            permissions: [],
            selectedRole: '',
            listUsers: [],
            isOpenModal: false,
            userSelected: "",
            userLdapSelected: {},
            filterArgs: "",
            filterUsers: [],
            updateFilterUsers: []
        };
    },
    computed: {
        permissionSelected() {
            return this.selectedRole
        },
        formatUserLdapPermission() {
            return this.userLdapSelected.memberOf.map((permission) => {
                const permissionFormatedCN = permission.split(',')[0].slice(3)
                return permissionFormatedCN
            }).map((group) => ({
                name: group, readable_name: Keys[group] || null, status: 1
            })).filter((e) => e.readable_name)
        },
        formattedUnitUserLdap() {
            return this.userLdapSelected.unit
        },
        accessLevel() {
            return permissionAccess(this.perfilUser)
        },
        isUnitDCC() {
            return GROUP_DCC.includes(this.userLdapSelected.unit)
        }
    },
    created() {
        this.userService = new UserService()
        this.permissionService = new PermissionService()
    },
    mounted() {
        this.searchPermissionsAll();
    },
    methods: {
        async searchPermissionsAll() {
            await this.permissionService.all().then((response) => {
                this.permissions = response
                    .filter(({name}) => !name.includes('pmdf_all'))
                    .map(({id, name, readable_name}) => {
                        return { id, name, readable_name }
                    })
                    .sort((a, b) => a.readable_name > b.readable_name ? 1 : -1);
            }).catch((error) => {
                console.error("Error fetching permissions:", error);
            });
        },
        async searchUsers(permission) {
            if (permission.includes('pmdf_all')) {
                await this.permissionService.searchGroup({ permission })
                .then((response) => {
                    this.listUsers = response
                        .map(({id, employeeid, displayname, department, unidade_id}) => {
                            return { id, employeeid, name: displayname, unit: (department === "DISABLED" ? null : department), unit_id: unidade_id }
                        })
                        .sort((a, b) => a.name < b.name ? 1 : -1);
                }).catch((error) => {
                    console.error("Error fetching users:", error);
                    this.listUsers = [];
                });
                return
            }
            await permissionLdap
                .membersGroupLdap(permission)
                .then(({attributes}) => {
                    const parsed = attributes[0].vals.map(str => {
                        const parts = str.split(',');
                        const name = parts.find(p => p.startsWith('CN=')).slice(3)
                        let unit = parts.find(p => p.startsWith('OU=')).slice(3)
                        if (unit === "GROUPS") return null
                        if (unit === "PMDF_ALL") unit = "OUTRAS UNIDADES"
                        if (unit === "DISABLED") unit = "USUARIO DESATIVADO"
                        return { name, unit } 
                    })
                    .filter((e) => e)
                    .sort((a, b) => a.name < b.name ? 1 : -1)
                    this.listUsers = parsed
                }).catch((error) => {
                    this.listUsers = []
                    console.error("Error fetching users:", error);
                }).finally(() => {
                    this.loading = false
                });
        },
        async selectedUser(user) {
            let info = {}
            if (!user.unit_id || GROUP_DCC.includes(user.unit_id)) {
                const {attributes, objectName} = await userLdap.getUserLdap({cn: user.name})
                info.objectName = objectName
                const listMemberOf = attributes.filter(attr => attr.type === 'memberOf')[0].vals
                this.userLdapSelected.memberOf = listMemberOf
                info.employeeId = attributes.filter(attr => attr.type === 'employeeID')[0].vals[0] || null
            }
            if (user.id && !GROUP_DCC.includes(user.unit_id)) {
               const response = await this.permissionService.user({idUser: user.id})
               info.employeeId = user.employeeid
               this.userLdapSelected.memberOf = response.map((permission) => {
                    return permission.name
                })
            } 
            
            return this.userService.searchUserId({employeeId: info.employeeId})
                .then(([userDB]) => {
                    this.userLdapSelected.objectName = info.objectName
                    this.userSelected = userDB.displayname
                    this.userLdapSelected.unit = userDB.unidade_id
                    this.userLdapSelected.id = userDB.id
                    
                    setTimeout(() => {
                        this.isOpenModal = true
                    }, 500)
                })
                .catch((error) => {
                    console.error("Error fetching user DB:", error);
                })
                .finally(() => {
                    
                });
        },
        savePermissionUser() {
            this.isOpenModal = false
            notificationSuccess('Sucesso!', `As permissões foram atualizadas com sucesso!`, 5000, false)
        }
    },
    watch: {
        selectedRole(newValue) {
           this.searchUsers(newValue)
        },
        filterArgs(newValue) {
            this.updateFilterUsers = this.listUsers.filter((user) => {
                const nameMatch = user.name.toLowerCase().includes(newValue.toLowerCase())
                const unitMatch = user.unit.toLowerCase().includes(newValue.toLowerCase())
                return nameMatch || unitMatch
            })

        },
        permissionSelected(newValue) {
            this.updateFilterUsers = []
            this.filterArgs = ''
        }
    },
};
</script>